import RoleDetailModal from './RoleDetailModal';
export default RoleDetailModal;
